import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["image", "enabled", "colorType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { IconFunctionalInformation12 } from '@cian/ui-kit-design-tokens/icons';
import styles from '../../styles/infoButton.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
const InfoButtonComponent = /*#__PURE__*/React.forwardRef(function IconButton(_ref, ref) {
  let {
      image,
      enabled = true,
      colorType = 'main'
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({}, rest), {}, {
    disabled: rest.disabled || !enabled,
    className: clsx(styles['button'], styles[colorType]),
    ref: ref,
    children: image ? image : /*#__PURE__*/_jsx(IconFunctionalInformation12, {
      color: "current_color"
    })
  }));
});

/**
 * Компонент кнопки-информера. <br />
 * Нужен для отображения справочной информации в тултипе или модалке.
 * Рекомендуем использовать иконку "i" но в случае необходимости допускаем замену на локальные иконки "?" или "!"
 *
 * [Ссылка на макет](https://www.figma.com/design/yvdXkIuHpCtDZAUxSVi8bY/%5BAPP%5D-InfoButton)
 */
export const InfoButton = /*#__PURE__*/React.memo(InfoButtonComponent);